
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getWorkOrderApplicationStatus} from 'sr/utils/api/masterData/workOrderApplicationStatus/getWorkOrderApplicationStatus'
export const fetchworkOrderApplicationStatus = createAsyncThunk(
  'getWorkOrderApplicationStatus',
  async () => {
    const response = await getWorkOrderApplicationStatus()
    return response?.data
  }
)


